import React from "react";
import { FormattedMessage } from "react-intl";

const AskRequestsHeader = props => {

  const { myType } = props;

  if (myType === "STUDIO") {
    return (<div className="askList-table-header">
      <div style={{ width: "3%" }} />
      <div style={{ width: "37%" }}><FormattedMessage id="generic.request" /></div>
      <div style={{ width: "20%" }}><FormattedMessage id="generic.customer" /></div>
      <div style={{ width: "14%" }}><FormattedMessage id="generic.status" /></div>
      <div style={{ width: "10%" }}><FormattedMessage id="generic.dates.send" /></div>
      <div style={{ width: "10%" }}><FormattedMessage id="generic.dates.fill" /></div>
      <div style={{ width: "6%" }} />
    </div>);
  } 
  return (<div className="askList-table-header">
    <div style={{ width: "3%" }} />
    <div style={{ width: "48%" }}><FormattedMessage id="generic.request" /> </div>
    <div style={{ width: "17%" }}><FormattedMessage id="generic.status" /> </div>
    <div style={{ width: "12%" }}><FormattedMessage id="generic.dates.receive" /></div>
    <div style={{ width: "14%" }}><FormattedMessage id="generic.dates.send" /> </div>
    <div style={{ width: "6%" }} />
  </div>);
  
};

export default AskRequestsHeader;